import EntryScanner from './EntryScanner';

export default EntryScanner;
